import RouteCategoryNote from "common/RouteCategoryNote";
import RouteListRenderer from "common/RouteListRenderer";

const PAGE_NAME = "Government Non AC Buses (Kolkata and Howrah)";

const GovernmentNonACBusesKolkataHowrah = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Here we list the government Non AC buses which are visible in and
          around Kolkata, Howrah, North and South and 24 Parganas. Most of the
          buses listed here are local, however there are some express services
          serving as connectors to distant locations.
        </p>

        <p className="my-4">
          The first of government bus services were brought in the city by
          Calcutta State Transport Corporation (CSTC) in 1946, followed by
          Calcutta Tramways Corportation (CTC) and West Bengal Surface Transport
          Corportion (WBSTC) in 1992. Government bus services in other districts
          are mainly handled by South Bengal State Transport Corporation (SBSTC)
          and North Bengal State Transport Corporation (NBSTC). Recently CSTC,
          CTC and WBSTC have been merged to form West Bengal Transport
          Corporation (WBTC).
        </p>

        <RouteCategoryNote pageName={PAGE_NAME} />
      </RouteListRenderer>
    </main>
  );
};

export default GovernmentNonACBusesKolkataHowrah;
